import actions from './actions'
import state from './state'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

// Add this to /src/store/index:
// import google_sheet from './google_sheet'



// WEBPACK FOOTER //
// ./src/store/google_sheet/index.js